export default __webpack_public_path__ + "static/media/pound.39a9ae4b.svg";